import styled from "styled-components";

export const MoreWrapper = styled.div<{ top?: string; left?: string }>`
  position: absolute;
  min-width: 240px;
  width: max-content;
  height: auto;
  padding: 20px;
  border-radius: 10px;
  background: #ffffff;
  border: 0.93px solid #d9d9d9;
  box-shadow: 0px 3.71px 3.71px 0px #00000040;
  box-sizing: border-box;
  top: ${(p) => (p.top ? p.top : "20px")};
  left: ${(p) => (p.left ? p.left : "0")};
  z-index: 100;

  > .name {
    font-family: Pretendard;
    font-size: 19px;
    font-weight: 700;
    margin-bottom: 20px;
    text-align: left;
  }

  > .info {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
`;

export const MoreItem = styled.div`
  gap: 12px;
  display: flex;
  font-family: Pretendard;
  font-size: 15px;
  font-weight: 500;
  justify-content: space-between;
  white-space: nowrap;

  > .name {
    font-weight: 600;
    min-width: 60px;
    display: flex;
    gap: 12px;

    > .info {
      font-weight: 500;
      font-size: 15px;
      min-width: 150px;
    }
  }
`;
